export class AddWorkOrderVendorParametersDto {
    vendorName: string;
    firstName: string;
    lastName: string;
    phone: string;
    fax: string;
    email: string;
    remitAddress: string;
    communityId: number;
    workOrderId: number;
}
